export const workspacesTableConfig = {
	defaultSortName: "upcomingMeeting",
	defaultSortDirection: "asc" as const,
	defaultPageNumber: 1,
	fallbackFilters: { status: "active" as const },
	pageSize: 25,
	statusOptions: ["any", "active", "archived"] as const,
};

export const actionItemsTableConfig = {
	defaultSortName: "created.timeStamp",
	defaultSortDirection: "desc" as const,
	defaultPageNumber: 1,
	fallbackFilters: { status: "incomplete" as const, dueDateRange: undefined, isUnassigned: [] },
	pageSize: 25,
	statusOptions: ["any", "incomplete", "complete"] as const,
};
